import { Module } from 'vuex'
import { UserInfo } from '@/plugins/tripartite-login'

/**
 * 第三授权平台方枚举
 */
export enum Plat {
  /** facebook */
  FB = 'facebook',
  /** google  */
  GG = 'google',
  /** Line */
  LE = 'line',
  /** apple */
  AP = 'apple',
  /** yahoo */
  YH = 'yahoo',
  /** tiktok */
  TK = 'tiktok',
}

// 平台值
export type platType = `${Plat}`;

export interface TripartiteUserInfo extends Record<string, any> {
  thirdCustomerEmail: string;
  thirdCustomerId: string;
  thirdCustomerName: string;
  thirdCustomerPhone?: string;
  thirdPlatform?: platType;
}

/** 更新三方用户授权信息 */
const UPDATE_TRIPARTITEUSERINFO = 'UPDATE_TRIPARTITEUSERINFO'
/** 退出登录,删除三方授权信息 */
const REMOVE_TRIPARTITEUSERINFO = 'REMOVE_TRIPARTITEUSERINFO'

const getInitState = () => {
  return {
    thirdCustomerEmail: '',
    thirdCustomerId: '',
    thirdCustomerName: '',
    thirdCustomerPhone: '',
    thirdPlatform: undefined
  }
}
const module2: Module<TripartiteUserInfo, any> = {
  state: getInitState(),
  mutations: {
    // payload的值类型为UserInfo，
    // 则commit的形式须为store.commit(UPDATE_TRIPARTITEUSERINFO, userInfo)
    // 不能为commit(Object)
    [UPDATE_TRIPARTITEUSERINFO] (state, payload: UserInfo) {
      if (typeof payload === 'object' && payload !== null) {
        Object.entries(payload).forEach(([key, value]) => {
          state[key] = value
        })
      }
    },
    [REMOVE_TRIPARTITEUSERINFO] (state, payload = getInitState()) {
      Object.entries(payload).forEach(([key, value]) => {
        state[key] = value
      })
      console.log(state, 'state')
    }
  },
  getters: {
    getAll: (state) => state,
    getThirdCustomerId: (state) => state?.thirdCustomerId,
    getThirdPlatform: (state) => state?.thirdPlatform
  }
}

export { UPDATE_TRIPARTITEUSERINFO, REMOVE_TRIPARTITEUSERINFO }

export default module2
